"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Switcher = _interopRequireDefault(require("./Switcher"));

var _AnatomogramSvg = _interopRequireDefault(require("./AnatomogramSvg"));

var _Assets = require("./Assets");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Anatomogram =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Anatomogram, _React$Component);

  function Anatomogram(props) {
    var _this;

    _classCallCheck(this, Anatomogram);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Anatomogram).call(this, props));
    _this.state = {
      selectedView: (0, _Assets.getDefaultView)(props.species)
    };
    _this._switchAnatomogramView = _this._switchAnatomogramView.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Anatomogram, [{
    key: "_switchAnatomogramView",
    value: function _switchAnatomogramView(anatomogramView) {
      this.setState({
        selectedView: anatomogramView
      });
    }
  }, {
    key: "render",
    value: function render() {
      return _Assets.supportedSpecies.includes(this.props.species) && _react["default"].createElement("div", null, _react["default"].createElement(_Switcher["default"], {
        atlasUrl: this.props.atlasUrl,
        species: this.props.species,
        selectedView: this.state.selectedView,
        onChangeView: this._switchAnatomogramView
      }), _react["default"].createElement(_AnatomogramSvg["default"], _extends({
        atlasUrl: this.props.atlasUrl
      }, this.props, {
        selectedView: this.state.selectedView
      })));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if (props.species !== state.species) {
        return {
          species: props.species,
          selectedView: (0, _Assets.getDefaultView)(props.species)
        };
      }

      return null;
    }
  }]);

  return Anatomogram;
}(_react["default"].Component);

Anatomogram.propTypes = {
  atlasUrl: _propTypes["default"].string,
  species: _propTypes["default"].string.isRequired
};
Anatomogram.defaultProps = {
  atlasUrl: "https://www.ebi.ac.uk/gxa/"
};
var _default = Anatomogram;
exports["default"] = _default;